export const CHAT_CONSTANTS = {
   INPUT_PLACEHOLDER: 'Type your message...',
   MENTION_TRIGGER: '@',
   MENTION_CHIP_CLASS: 'mention-chip',
   MENTION_FORMAT: '@[?]',
   CHIP_PREFIX: '@',
   NON_BREAKING_SPACE: '\u00A0',
   SPACE: ' ',
   NEWLINE: '\n',
};
